import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	dialogActions: {
		padding: "16px 24px"
	}
})

export default useStyles
